import { findCatalogFileEntry, findCatalogOperatorRow } from '@buxus/shared'
import { idbGetOperatorFile } from './operatorFileIdb'

/** Zoho Creator / Buxus API success code (see BuxusConsts.ApiResponseCodeSuccess). */
export const BUXUS_API_SUCCESS_CODE = 3000

/**
 * Quick check before opening a pop-up tab: catalog SAS row or IndexedDB cache from download.
 */
export async function isOperatorFileAvailable(
  operatorId: string,
  operatorVersion: string | null | undefined,
  fileId: string,
  fileExt: string | undefined,
  catalog: ReadonlyArray<Record<string, unknown>> | null | undefined,
): Promise<boolean> {
  const want = fileId.trim()
  if (!want) return false

  const row = findCatalogOperatorRow(catalog, operatorId)
  if (findCatalogFileEntry(row, want, fileExt)) return true

  const version = operatorVersion?.trim()
  if (version) {
    const cached = await idbGetOperatorFile(operatorId, want, version)
    if (cached) return true
  }

  return false
}
